import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { NamedItemType, OrganisationLovResponse } from '@interfaces-clean/organisationLov.interface';
import { getData } from '@apis/rest-client';

const centralMonitoringOrgLovUrl = 'CentralMonitoring/OrganisationLov';
const subjectMonitoringOrgLovUrl = 'SubjectMonitoring/OrganisationLov';

const OrganisationLovApi = {
    useGet: (studyRef: string, lovType: NamedItemType, isSubjectMonitoring?: boolean) => {
        return useSWR(
            `${isSubjectMonitoring ? subjectMonitoringOrgLovUrl : centralMonitoringOrgLovUrl}`,
            (url: string) => {
                return getData<OrganisationLovResponse[]>(`${url}/${studyRef}/${lovType}`, { timeout: 30000 });
            },
        );
    },
    useLazyGet: (studyRef: string, lovType: NamedItemType, isSubjectMonitoring?: boolean) => {
        const url = `${isSubjectMonitoring ? subjectMonitoringOrgLovUrl : centralMonitoringOrgLovUrl}`;
        return useSWRMutation(`${url}/${studyRef}/${lovType}`, (getDataUrl: string) => {
            return getData<OrganisationLovResponse[]>(getDataUrl, { timeout: 30000 });
        });
    },
};

export default OrganisationLovApi;
